import React, {Component} from "react";

import {getSize, CCUtils,CCCounterItem , strings} from './../../cc-imports'


class CCCounter extends Component {

    constructor(props) {
        super(props);
        this.state = {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0
        }
    }

    static propTypes = {}
    static defaultProps = {
        title: 'Hours'
    }

    componentDidMount() {
        const {date} = this.props;
        setInterval(
            () => {
                this.setState(CCUtils.getDateDiff(new Date(date), new Date()));
            },
            1000
        );
        setImmediate(
            () => {
                this.setState(CCUtils.getDateDiff(new Date(date), new Date()));
            },
            1000
        );
    }

    render() {
        const {days, hours, minutes, seconds} = this.state;
        const {style} = this.props;
        return (
            <div className={'flex-container'} style={{...{justifyContent:'center', alignItems:'center'}, ...style}}>
                <div className={'flex-container'} style={{flex: 1, flexDirection: 'row'}}>
                    <CCCounterItem  title={strings('countdown_days')} value={days}/>
                    <CCCounterItem  title={strings('countdown_hours')} value={hours} style={{marginLeft: 6}}/>
                    <CCCounterItem title={strings('countdown_minutes')} value={minutes} style={{marginLeft: 6}}/>
                    <CCCounterItem title={strings('countdown_seconds')} value={seconds} style={{marginLeft: 6}}/>
                </div>
            </div>
        );
    }
}

export default CCCounter


// WEBPACK FOOTER //
// ./src/app/components/CCCounter/CCCounter.js